query AccountsCommonData {
  travelAccountTypes(orderBy: ID_ASC) {
    nodes {
      id
      accountType
    }
  }
  departmentGroups(
    filter: { isTravelDepartmentGroup: { equalTo: true } }
    orderBy: NAME_ASC
  ) {
    nodes {
      id
      name
      isTravelDepartmentGroup
    }
  }
}
